/* ZSportsTech — section-clhero.js
   Scoped to #sc-clhero (Z-Bat Clinic hero). Vanilla JS only, namespaced.
   One-shot count-up on the telemetry values when the hero enters view.
   Maps to → assets/section-clhero.js in Shopify theme.
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var hero = document.getElementById('sc-clhero');
  if (!hero) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var values = [].slice.call(hero.querySelectorAll('.sc-clhero__metric-value[data-count]'));

  /* Reduced motion: leave final values in place, do nothing else. */
  if (reduce || !values.length) return;

  function countUp(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    if (isNaN(target)) return;
    var dur = 1100, start = null;
    el.textContent = '0';
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      /* ease-out cubic */
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = String(target);
    }
    requestAnimationFrame(step);
  }

  function run() {
    values.forEach(function (el) { countUp(el); });
  }

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          run();
          obs.disconnect();
        }
      });
    }, { threshold: 0.35 });
    obs.observe(hero.querySelector('.sc-clhero__telemetry') || hero);
  } else {
    run();
  }
}());
